import { map } from 'rxjs/operators';
import webApi from '../../../Lib/WebApi';
import { callApi, camelizeObjectKeys } from '../../Helpers/rxjsHelpers';

const mapRootPathMapResponse = (r: any) => camelizeObjectKeys(r);

export const callApiPutConnections = (body: any) => {
  return callApi(webApi['serviceSetup.databaseConnection'].put(body));
};

export const callApiGetConnections = () => {
  return callApi(webApi['serviceSetup.databaseConnection'].get()).pipe(map((r) => mapRootPathMapResponse(r.Body)));
};
